import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import {
    getTimesheetApprovalsWithFilters, ApproveTimesheetForMobileAsync, SingleApprovedTimesheetTimeOffForMobileAsync
    , updateAllSelectedAndUnSelected, updateDescription, setApproved, setRejected, SingleRejectTimesheetTimeOffForMobileAsync
    , checkedState, unCheckedState, checkedAllState, unCheckedAllState, getTimeOffApprovalsWithFilters
    , ApprovedSelectedTimesheetTimeOffForMobileAsync, checkedStatetimeoff, unCheckedStatetimeoff
    , checkedAllStatetimeoff, unCheckedAllStatetimeoff, RejectSelectedTimesheetTimeOffForMobileAsync
    , RejectTimesheetForMobileAsync, SingleApproveTimesheetForMobileAsync, setComments, setCommentsTimeOff,
    updateValuesFromGlobalState, updateIsLoading, SingleApproveOrRejectAsync,
    updateTimesheetApprovalDataForPrint,
    getTimesheetApprovalsFilters,
    updateToReoladTimesheetApproval,
    resetFiltersState
} from '../../timesheet/timesheetSlice';
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers';
import TimesheetApprovalFilter from "./TimesheetApprovalFilter";
import TaskOffCanvas from '../../../common/OffCanvas';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { resetAttachmentList } from '../../../features/attachment/AttachmentSlice';
import GetAttachments from '../../../features/attachment/AttachmentItem';
import './TimesheetApproval.css'
import moment from 'moment';
import TimesheetPrintViewWidget from '../../../features/timesheet/TimesheetPrintViewWidget';
import Loader from '../../../common/Loader';
import { ShowSwalWithConfirmationMessage } from "../../../common/SweetAlert";
import { ShowToast } from "../../../common/Toastr";
import { formatDateWithDateAndMonthName, determineCultureFormat, getValueFromResource, FormatInvoiceDecimalNumber } from '../../../common/timeLiveFunction';
import { getCustomPagePermissionsAsync, getGlobalAccountPreferenceDataAsync } from '../../../common/GlobalSlice';
import { parseISO, format } from "date-fns"
import { displayValueForTimeEntry } from '../../../common/timesheetFunction';
import { useLocation } from 'react-router-dom';

const initialValueForPermission = {
    IsMyTimeOff: false,// 142
}


const TimesheetApproval = () => {
    //Attachment Work
    const modalAttachmentRef = useRef<any>(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [childs, setChilds] = useState(initialValueForPermission);
    const [getAccountEmployeeTimeEntryPeriodId, setAccountEmployeeTimeEntryPeriodId] = useState('');
    useEffect(() => {
        if (modalIsOpen) {
            if (modalAttachmentRef.current) {
                modalAttachmentRef.current.click();
            }
        }
    }, [modalIsOpen]);
    const handleAttachment = (accountEmployeeTimeEntryPeriodId: any) => {
        setAccountEmployeeTimeEntryPeriodId(accountEmployeeTimeEntryPeriodId);
        dispatch(resetAttachmentList());
        setModalIsOpen(true);
    }
    //Attachment Work
    const [tab, setTab] = useState('TimesheetApprovalList');
    const [isOpenTimesheetPrintModal, setIsOpenTimesheetPrintModal] = useState<any>();
    const [AccountEmployeeIdRowsClick, setAccountEmployeeIdRowsClick] = useState<any>();
    const [propSystemApproverType, setpropSystemApproverType] = useState<any>();
    const [startDate, setstartDate] = useState<any>();
    const [endDate, setendDate] = useState<any>();
    const modelRef = useRef<any>(null);
    const { isLoadingApproval, isReloadApproval, accountEmployeeId, timeoffApprovalList, timesheetApprovalList, timeEntryAccountEmployeeId } = useAppSelector((state) => state.timesheet);
    const { sessionAccountEmployeeId, cultureInfoName, decimalFormat, decimalPlaces, IsTimesheetApprovalReasonMandatory } = useAppSelector((state) => state.globalState);
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const location = useLocation();
    const [showDecimal, setShowDecimal] = useState(false);
    const isInitialLoad = useRef(true);
    // const { widgetFilters, fromDashboard } = location.state || {};
    const params = new URLSearchParams(location.search);
    const encoded = params.get("data");
    const parsedState = React.useMemo(() => {
        const encoded = params.get("data");
        return encoded ? JSON.parse(decodeURIComponent(encoded)) : {};
    }, [encoded]);
     const { widgetFilters = null, fromDashboard = false } = parsedState;
    const generalObject = {
        "name": getValueFromResource("Filters", dispatch, t),
        "width": "500px",
        "componentName": <TimesheetApprovalFilter />
    }


const [commentModalOpen, setCommentModalOpen] = useState(false);
const [modalCommentText, setModalCommentText] = useState('');
const [pendingActionData, setPendingActionData] = useState<{
    isBulk: boolean;
    isApprove: boolean;
    singleItemData?: { AccountEmployeeId: string; AccountEmployeeTimeEntryPeriodId: string; actionId: string };
} | null>(null);


const handleSaveModalComment = () => {
    if (!modalCommentText.trim()) return;
    if (!pendingActionData) return;

    if (pendingActionData.isBulk) {
        const updatedList = timesheetApprovalList.map((item: any) => {
            if (item.isSelected && (!item.Comments || !item.Comments.trim())) {
                dispatch(setComments({ AccountEmployeeTimeEntryPeriodId: item.AccountEmployeeTimeEntryPeriodId, Comments: modalCommentText }));
                return { ...item, Comments: modalCommentText };
            }
            return item;
        });

        setCommentModalOpen(false);
        executeBulkTimesheetAction(pendingActionData.isApprove, updatedList);
    } else if (pendingActionData.singleItemData) {
        const { AccountEmployeeTimeEntryPeriodId, actionId } = pendingActionData.singleItemData;
        dispatch(setComments({ AccountEmployeeTimeEntryPeriodId, Comments: modalCommentText }));
        const updatedList = timesheetApprovalList.map((item: any) => {
            if (item.AccountEmployeeTimeEntryPeriodId === AccountEmployeeTimeEntryPeriodId) {
                return { ...item, Comments: modalCommentText };
            }
            return item;
        });

        setCommentModalOpen(false);

        // 3. Updated list function ko pass karein
        executeSingleTimesheetAction(AccountEmployeeTimeEntryPeriodId, actionId, updatedList);
    }
};
   
    useEffect(() => {
        return () => {
            dispatch(resetFiltersState());
        };
    }, [dispatch]);

    useEffect(() => {
        if (fromDashboard) {
            // setTab('TimesheetApprovalList');
            if (isInitialLoad.current) {
                setTab('TimesheetApprovalList');
                isInitialLoad.current = false;
            }
            let approverEmployeeId: Number = 0;
            if (sessionAccountEmployeeId !== 0) {
                approverEmployeeId = sessionAccountEmployeeId;
            }
           
            const startDate = widgetFilters?.DateRange?.startDate ? widgetFilters.DateRange.startDate : moment().subtract(3, 'months').format('YYYY-MM-DD')
            const endDate = widgetFilters?.DateRange?.endDate ? widgetFilters.DateRange.endDate : moment().format('YYYY-MM-DD');
            const payload = {
                sesssionEmployeeId: sessionAccountEmployeeId,
                startDate: startDate,
                endDate: endDate,
                includeDateRange: widgetFilters?.IncludeDateRange ?? true,
                projectvalue: widgetFilters?.AccountProjectId[0] ? `${widgetFilters?.AccountProjectId[0]}` : 0,
                employeeValues: widgetFilters?.AccountEmployeeId[0] ? `${widgetFilters?.AccountEmployeeId[0]}` : 0
            }
            //accountEmployeeId == 0 && dispatch(updateValuesFromGlobalState(sessionAccountEmployeeId))
            // dispatch(getTimesheetApprovalsFilters(payload)).then((result) => {
            //     dispatch(getTimeOffApprovalsWithFilters(approverEmployeeId));
            // }).catch((error) => {
            // });
            if (tab === 'TimeoffApprovalList') {
                dispatch(getTimeOffApprovalsWithFilters(approverEmployeeId));
            } else {
                dispatch(getTimesheetApprovalsFilters(payload)).catch(() => { });
            }
        }
    }, [isReloadApproval, fromDashboard, tab]);
  
    useEffect(() => {
        if (fromDashboard) return;
        if (isInitialLoad.current) {
            setTab('TimesheetApprovalList');
            isInitialLoad.current = false;
            let approverEmployeeId: Number = 0;
            if (sessionAccountEmployeeId !== 0) {
                approverEmployeeId = sessionAccountEmployeeId;
            }
            dispatch(getTimesheetApprovalsWithFilters(approverEmployeeId)).then(() => {
                dispatch(getTimeOffApprovalsWithFilters(approverEmployeeId));
            }).catch(() => { });
            return;
        }

        let approverEmployeeId: Number = 0;
        if (sessionAccountEmployeeId !== 0) {
            approverEmployeeId = sessionAccountEmployeeId;
        }

        if (tab === 'TimeoffApprovalList') {
            dispatch(getTimeOffApprovalsWithFilters(approverEmployeeId));
        } else {
            dispatch(getTimesheetApprovalsWithFilters(approverEmployeeId));
        }
    }, [isReloadApproval]);

    const handleCheckboxChange = (e: any, index: number) => {
        if (e.target.checked) {
            dispatch(checkedState(index));
        } else {
            dispatch(unCheckedState(index));
        }
    };

    const handleCheckboxChangetimeoff = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedStatetimeoff(rowId))
        } else {
            dispatch(unCheckedStatetimeoff(rowId))
        }
    }

    const handleCommentsChange = (e: any, AccountEmployeeTimeEntryPeriodId: any) => {
        dispatch(setComments({ AccountEmployeeTimeEntryPeriodId: AccountEmployeeTimeEntryPeriodId, Comments: e.target.value }))

    }

    const handleCommentsChangeTimeOff = (e: any, AccountEmployeeTimeEntryId: any) => {
        dispatch(setCommentsTimeOff({ AccountEmployeeTimeEntryId: AccountEmployeeTimeEntryId, Comments: e.target.value }))

    }

    const renderEmployeeNameWithSystemApproverType = (FullName: string, StartDate: any, EndDate: any, SystemApproverTypeId: any) => {
        let SystemApproverType: string = "";
        let SystemApproverTypeToolTip: string = "";
        if (SystemApproverTypeId == 1) {
            SystemApproverType = "(TL)";
            SystemApproverTypeToolTip = "Team Lead";
        }
        else if (SystemApproverTypeId == 2) {
            SystemApproverType = "(PM)";
            SystemApproverTypeToolTip = "Project Manager";
        }
        else if (SystemApproverTypeId == 3) {
            SystemApproverType = "(SE)";
            SystemApproverTypeToolTip = "Specific Employee";
        }
        else if (SystemApproverTypeId == 4) {
            SystemApproverType = "(EU)";
            SystemApproverTypeToolTip = "External User";
        }
        else if (SystemApproverTypeId == 5) {
            SystemApproverType = "(EM)";
            SystemApproverTypeToolTip = "Employee Manager";
        }
        return (
            <>
                <a className='text-dark fw-bold d-block mb-1'>
                    {FullName} {SystemApproverType}
                </a>
                <span style={{ color: '#7b8ba6', fontSize: 11, display: 'inline-flex', alignItems: 'center' }} >
                    <i className="ki-outline ki-calendar text-gray fs-4 me-1"></i>
                    {/* {`${moment.parseZone(StartDate).format('DD MMM yy')} - ${moment.parseZone(EndDate).format('DD MMM yy')}`} */}
                    {formatDateWithDateAndMonthName(StartDate, cultureInfoName.toString())} - {formatDateWithDateAndMonthName(EndDate, cultureInfoName.toString())}
                </span>
            </>
        );
    }

    // const handleButtonClick = (e: any, AccountEmployeeId: string, AccountEmployeeTimeEntryPeriodId: string, Status: string = "") => {
    //     let id = e.currentTarget.id;
    //     ShowSwalWithConfirmationMessage(`Are you sure you want to ${id} this record?`, "", `Yes, Proceed`)
    //         .then((result) => {
    //             if (result) {
    //                 if (id === "Approved") {
    //                     const foundItems = timesheetApprovalList.filter((item: any) => item.AccountEmployeeTimeEntryPeriodId === AccountEmployeeTimeEntryPeriodId);
    //                     if (foundItems) {
    //                         dispatch(SingleApproveOrRejectAsync({ List: foundItems, id: id }))
    //                             .unwrap()
    //                             .then((originalPromiseResult) => {
    //                                 if(originalPromiseResult.StatusCode === "200") {
    //                                     ShowToast("Approved Successfully", 'Success', "success", "toast-top-right");
    //                                      dispatch(updateToReoladTimesheetApproval(true));
    //                                 }else{
    //                                     ShowToast('Error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");

    //                                 }
    //                             })
    //                             .catch((error) => {
    //                                 ShowToast('Error', error.message, "error", "toast-top-right");
    //                             });
    //                     }
    //                 } else if (id === "Rejected") {
    //                     const foundItems = timesheetApprovalList.filter((item: any) => item.AccountEmployeeTimeEntryPeriodId === AccountEmployeeTimeEntryPeriodId);
    //                     if (foundItems) {
    //                         dispatch(SingleApproveOrRejectAsync({ List: foundItems, id: id }))
    //                             .unwrap()
    //                             .then((originalPromiseResult) => {
    //                                 originalPromiseResult.StatusCode === "200" ?
    //                                     ShowToast("Rejected Successfully", 'Success', "success", "toast-top-right") :
    //                                     ShowToast('Error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
    //                             })
    //                             .catch((error) => {
    //                                 ShowToast('Error', error.message, "error", "toast-top-right");
    //                             });
    //                     }
    //                 }
    //             }
    //         })
    //         .catch((error) => {
    //             ShowToast('Error', error.message, "error", "toast-top-right");
    //         });
    // };

const executeSingleTimesheetAction = (AccountEmployeeTimeEntryPeriodId: string, id: string, currentList?: any[]) => {
    const isApprove = id?.toLowerCase() === "approved" || id?.toLowerCase() === "approve";
    const actionText = isApprove ? "approve" : "reject";

    ShowSwalWithConfirmationMessage(`Are you sure you want to ${actionText} this record?`, "", "Yes, Proceed")
        .then((result) => {
            if (result) {
                const listToUse = currentList || timesheetApprovalList;
                const foundItems = listToUse.filter(
                    (item: any) => item.AccountEmployeeTimeEntryPeriodId === AccountEmployeeTimeEntryPeriodId
                );
                if (foundItems.length > 0) {
                    dispatch(SingleApproveOrRejectAsync({ List: foundItems, id: id }))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            if (originalPromiseResult.StatusCode === "200") {
                                ShowToast(
                                    `${isApprove ? "Approved" : "Rejected"} Successfully`, "Success", "success", "toast-top-right");
                                dispatch(updateToReoladTimesheetApproval(true));
                            } else {
                                ShowToast("Error", originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                            }
                        })
                        .catch((error) => {
                            ShowToast("Error", error.message || "An error occurred", "error", "toast-top-right");
                        });
                }
            }
        })
        .catch((error) => {
            ShowToast("Error", error.message || "Confirmation error", "error", "toast-top-right");
        });
};


const executeBulkTimesheetAction = (isApproved: boolean, currentList?: any[]) => {
    const message = isApproved
        ? 'Are you sure you want to approve these records?'
        : 'Are you sure you want to reject these records?';

    ShowSwalWithConfirmationMessage(message, "", 'Yes, Proceed')
        .then((result) => {
            if (result) {
                dispatch(updateIsLoading(true));
                const listToFilter = currentList || timesheetApprovalList;
                const filteredTeamList = listToFilter.filter(user => user.isSelected);

                const action = isApproved
                    ? ApproveTimesheetForMobileAsync
                    : RejectTimesheetForMobileAsync;

                dispatch(action(filteredTeamList))
                    .unwrap()
                    .then((originalPromiseResult) => {
                        if (originalPromiseResult.StatusCode === "200") {
                            ShowToast(isApproved ? "Approved Successfully" : "Rejected Successfully", 'Success', "success", "toast-top-right");
                            dispatch(updateToReoladTimesheetApproval(true));
                        } else {
                            ShowToast('Error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        }
                    })
                    .catch(() => {
                        ShowToast('Error', 'An error occurred while processing the request.', "error", "toast-top-right");
                    })
                    .finally(() => {
                        dispatch(updateIsLoading(false));
                    });
            }
        })
        .catch(() => {
            ShowToast('Error', 'Confirmation dialog error', "error", "toast-top-right");
        });
};



const handleButtonClick = (e: any, AccountEmployeeId: string, AccountEmployeeTimeEntryPeriodId: string, Status: string = "") => {
    let id = e.currentTarget.id;
    const targetItem = timesheetApprovalList.find((item: any) => item.AccountEmployeeTimeEntryPeriodId === AccountEmployeeTimeEntryPeriodId);

    if (IsTimesheetApprovalReasonMandatory && (!targetItem?.Comments || !targetItem.Comments.trim())) {
        setPendingActionData({
            isBulk: false,
            isApprove: id === "approve",
            singleItemData: { AccountEmployeeId, AccountEmployeeTimeEntryPeriodId, actionId: id }
        });
        setModalCommentText('');
        setCommentModalOpen(true);
        return;
    }

    executeSingleTimesheetAction(AccountEmployeeTimeEntryPeriodId, id);
};

    const handleButtonClickForTimeOff = (e: any, AccountEmployeeId: string, AccountEmployeeTimeEntryId: string, Status: string) => {
        let id = e.currentTarget.id;
        ShowSwalWithConfirmationMessage(`Are you sure you want to ${id} this record?`, "", `Yes, Proceed`)
            .then((result) => {
                if (result) {
                    const founditem = timeoffApprovalList.find((item: any) => item.AccountEmployeeTimeEntryId === AccountEmployeeTimeEntryId);
                    if (id === "Approved") {
                        dispatch(SingleApprovedTimesheetTimeOffForMobileAsync(founditem))
                            .unwrap()
                            .then((originalPromiseResult) => {
                                originalPromiseResult.StatusCode === "200" ?
                                    ShowToast("Approved Successfully", 'Success', "success", "toast-top-right") :
                                    ShowToast('Error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                            })
                            .catch((error) => {
                                ShowToast('Error', error.message, "error", "toast-top-right");
                            });

                    } else if (id === "Rejected") {
                        const founditem = timeoffApprovalList.find((item: any) => item.AccountEmployeeTimeEntryId === AccountEmployeeTimeEntryId);
                        dispatch(SingleRejectTimesheetTimeOffForMobileAsync(founditem))
                            .unwrap()
                            .then((originalPromiseResult) => {
                                originalPromiseResult.StatusCode === "200" ?
                                    ShowToast("Rejected Successfully", 'Success', "success", "toast-top-right") :
                                    ShowToast('Error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                            })
                            .catch((error) => {
                                ShowToast('Error', error.message, "error", "toast-top-right");
                            });
                    }
                }
            })
            .catch((error) => {
                ShowToast('Error', error.message, "error", "toast-top-right");
            });
    };

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    }

    const handleSelectAllChangetimeoff = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllStatetimeoff());
        } else {
            dispatch(unCheckedAllStatetimeoff());
        }
    }


const onDeleteSelectedClick = (isApproved: boolean) => {
    const selectedItems = timesheetApprovalList.filter(user => user.isSelected);
    if (IsTimesheetApprovalReasonMandatory) {
        const hasMissingComment = selectedItems.some(item => !item.Comments || !item.Comments.trim());
        if (hasMissingComment) {
            setPendingActionData({
                isBulk: true,
                isApprove: isApproved
            });
            setModalCommentText('');
            setCommentModalOpen(true);
            return;
        }
    }

   
    executeBulkTimesheetAction(isApproved);
};


    const onDeleteSelectedClickTimeOff = (isApproved: boolean) => {
        const message = isApproved
            ? 'Are you sure you want to approve these records?'
            : 'Are you sure you want to reject these records?';

        const confirmButtonText = 'Yes, Proceed';

        ShowSwalWithConfirmationMessage(message, "", confirmButtonText)
            .then((result) => {
                if (result) {
                    dispatch(updateIsLoading(true));
                    const filteredTeamList = timeoffApprovalList.filter(user => user.isSelected);
                    const action = isApproved
                        ? ApprovedSelectedTimesheetTimeOffForMobileAsync
                        : RejectSelectedTimesheetTimeOffForMobileAsync;
                    dispatch(action(filteredTeamList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            if (originalPromiseResult.StatusCode === "200") {
                                ShowToast(isApproved ? "Approved Successfully" : "Rejected Successfully", 'Success', "success", "toast-top-right");
                            } else {
                                ShowToast('Error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                            }
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('Error', 'An error occurred while processing the request.', "error", "toast-top-right");
                        })
                        .finally(() => {
                            dispatch(updateIsLoading(false));
                        });
                }
            })
            .catch((error) => {
                ShowToast('Error', 'Confirmation dialog error', "error", "toast-top-right");
            });
    }

    const triggerTimesheetPrintView = (accountEmployeeTimeEntryPeriodId: string, SystemApproverType: string, startDate: Date, endDate: Date, accountEmployeeId: number, approvalEmployeeName : string) => {
        setIsOpenTimesheetPrintModal(accountEmployeeTimeEntryPeriodId);
        setpropSystemApproverType(SystemApproverType);
        setstartDate(moment.parseZone(startDate).format('YYYY-MM-DD'));
        setendDate(moment.parseZone(endDate).format('YYYY-MM-DD'));
        setAccountEmployeeIdRowsClick(accountEmployeeId);
        //modelRef.current.click();
        dispatch(updateTimesheetApprovalDataForPrint({
            timeEntryPeriodIdForPrint: accountEmployeeTimeEntryPeriodId,
            isForTimesheet: false,
            systemApproverTypeForPrint: SystemApproverType,
            startDateForPrint: moment.parseZone(startDate).format('YYYY-MM-DD'),
            endDateForPrint: moment.parseZone(endDate).format('YYYY-MM-DD'),
            rowAccountEmployeeIdForPrint: accountEmployeeId,
            approvalEmployeeName: approvalEmployeeName
        }));
    }

    useLayoutEffect(() => {
        dispatch(getCustomPagePermissionsAsync("142")).then((res) => {
            if (res.meta.requestStatus === 'fulfilled') {
                let permissions = res.payload;
                setChilds({
                    ...childs,
                    IsMyTimeOff: getPermission(142, permissions),
                });
            }
        }).catch()
    }, []);

    function getPermission(id: any, permissions: any) {
        const permission = permissions.find((x: any) => x.Id === id);
        return permission ? permission.IsList : false;
    }
    useEffect(() => {
        dispatch(getGlobalAccountPreferenceDataAsync()).then((result) => {
            if (result.payload?.data?.length > 0) {
                const decimalFormat = result.payload?.data[0]?.SystemTimeEntryHoursFormat == 'Time' ? false : true;
                setShowDecimal(decimalFormat);
                console.log(result.payload?.data, decimalFormat, "result");
            }
        })
            .catch((error) => {
                console.log(error, "error");
            })
    }, [])

    return (
        <>
            {isLoadingApproval && <Loader />}
            {modalIsOpen && (
                <>
                    <div className="modal drawer-overlay" tabIndex={-1} id="attachmentModel" data-bs-backdrop="false">
                        <div className="modal-dialog modal-xl">
                            <div className="modal-content rounded">
                                <div className='modal-header pb-2'>
                                    <h5 className='headerTitle'>
                                        {/* {t('Attachment')} */}
                                        {getValueFromResource('Attachment', dispatch, t)}
                                    </h5>
                                    <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal' onClick={() => setModalIsOpen(false)}>
                                        <KTIcon iconName='cross' className='fs-1' />
                                    </div>
                                </div>
                                <div className='modal-body pt-0 pb-15 px-5 px-xl-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
                                    <GetAttachments Id={getAccountEmployeeTimeEntryPeriodId} AccountAttachmentTypeId={2} IsShowEmployeeInformation={false} />
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                                        data-bs-dismiss="modal"
                                        onClick={() => setModalIsOpen(false)}
                                    >
                                        {/* {t('Close')} */}
                                        {/* {getValueFromResource('Cancel', dispatch, t)} */}
                                        {getValueFromResource('Close', dispatch, t)}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button ref={modalAttachmentRef} type="button" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#attachmentModel">
                        {/* {t('Launch demo modal')} */}
                        {getValueFromResource('Launch demo modal', dispatch, t)}
                    </button>
                </>
            )}
       {commentModalOpen && (
    <>
        <div className="modal fade show d-block drawer-overlay" tabIndex={-1} id="commentModal" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content rounded">
                    <div className="modal-header pb-2">
                        <h5 className="headerTitle">
                            {getValueFromResource('Comments', dispatch, t) || 'Comments'}
                        </h5>
                        <div 
                            className="btn btn-sm btn-icon btn-active-color-primary" 
                            onClick={() => setCommentModalOpen(false)}
                        >
                            <KTIcon iconName="cross" className="fs-1" />
                        </div>
                    </div>

                       <div className="modal-body pt-3 pb-4 px-4">
                        <p className="text-gray-700 required fs-6 mb-3 text-start">
                            {getValueFromResource('Please enter comment to proceed', dispatch, t) || 'Please enter comment to proceed with approval/rejection:'}
                        </p>
                        <textarea
                            className="form-control required fs-7 fw-normal"
                            rows={4}
                             placeholder={getValueFromResource('Enter comments...', dispatch, t) || 'Enter comments...'}
                            value={modalCommentText}
                            onChange={(e) => setModalCommentText(e.target.value)}
                            style={{ borderRadius: 2 }}
                            autoFocus
                        />
                    </div>

                    <div className="modal-footer py-2">
                        <button
                            type="button"
                            className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                            onClick={() => setCommentModalOpen(false)}
                        >
                            {getValueFromResource('Cancel', dispatch, t) || 'Cancel'}
                        </button>
                                    <span
                                        style={{
                                            display: "inline-block",
                                            cursor: !modalCommentText.trim() ? "not-allowed" : "default"
                                        }}
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-bs-btn-font-weight btn-sm fs-7"
                                            disabled={!modalCommentText.trim()}
                                            onClick={handleSaveModalComment}
                                            style={{
                                                opacity: !modalCommentText.trim() ? 0.45 : 1,
                                                pointerEvents: !modalCommentText.trim() ? "none" : "auto"
                                            }}
                                        >
                                            {getValueFromResource('Ok', dispatch, t) || 'Ok'}
                                        </button>
                                    </span>
                    </div>
                </div>
            </div>
        </div>
    </>
)}
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold headerTitle">
                        {/* {t("Approvals")} */}
                        {getValueFromResource('Approvals', dispatch, t)}
                    </h3>
                    {tab === 'TimesheetApprovalList' && (
                    <div className="card-toolbar align-items-center">
                        <a id="kt_OffCanvas"
                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content=
                            // {t("Filters")}
                            {getValueFromResource('Filters', dispatch, t)}
                            data-tooltip-place="bottom">
                            <i className="bi bi-filter fs-3 iconColor"></i>
                        </a>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div className="card-toolbar align-items-center">
                            <button
                                type="button"
                                className={`btn btn-sm btn-outline me-2 mb-0 btn-active-light-success text-success fs-7`}
                                onClick={(e: any) => { tab === 'TimesheetApprovalList' ? onDeleteSelectedClick(true) : onDeleteSelectedClickTimeOff(true) }}
                                style={{ display: tab === 'TimesheetApprovalList' ? (timesheetApprovalList.some((item: any) => item.isSelected === 1) ? 'block' : 'none') : (timeoffApprovalList.some((item: any) => item.isSelected === 1) ? 'block' : 'none'), paddingLeft: 3, paddingRight: 6 }}
                            >
                                <i className="bi bi-check fs-3 text-success"></i>
                                {/* {t('Approve Selected')} */}
                                {getValueFromResource('Approve Selected', dispatch, t)}
                            </button>
                            <button
                                type="button"
                                className={`btn btn-sm btn-outline me-0 mb-0 btn-active-light-danger text-danger fs-7`}
                                onClick={(e: any) => { tab === 'TimesheetApprovalList' ? onDeleteSelectedClick(false) : onDeleteSelectedClickTimeOff(false) }}
                                style={{ display: tab === 'TimesheetApprovalList' ? (timesheetApprovalList.some((item: any) => item.isSelected === 1) ? 'block' : 'none') : (timeoffApprovalList.some((item: any) => item.isSelected === 1) ? 'block' : 'none'), paddingLeft: 3, paddingRight: 6 }}
                            // style={{ display: timesheetApprovalList.some((item: any) => item.isSelected === 1) ? 'block' : 'none', paddingLeft: 3, paddingRight: 6 }}
                            >
                                <i className="bi bi-x fs-3 text-danger"></i>
                                {/* {t('Reject Selected')} */}
                                {getValueFromResource('Reject Selected', dispatch, t)}
                            </button>
                        </div>
                    </div>)}
                </div>
                <div className="card card-custom admin-card">
                    {/* <div className="card-body py-3"> */}
                    <div className='card-Report-body py-3'>
                        <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap' role='tablist' style={{ marginTop: 8 }}>
                            <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer`, { active: tab === 'TimesheetApprovalList' })}
                                    onClick={() => setTab('TimesheetApprovalList')}
                                    role='tab'
                                    style={{ fontWeight: 500 }}
                                >
                                    {/* {t("Timesheet Approvals")} */}
                                    {getValueFromResource('Timesheet Approvals', dispatch, t)}
                                </a>
                            </li>
                            {childs.IsMyTimeOff && <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer`, { active: tab === 'TimeoffApprovalList' })}
                                    onClick={() => setTab('TimeoffApprovalList')}
                                    role='tab'
                                    style={{ fontWeight: 500 }}
                                >
                                    {/* {t("Timeoff Approvals")} */}
                                    {getValueFromResource('Time Off Approvals', dispatch, t)}
                                </a>
                            </li>}
                        </ul>
                        <div className='tab-content pt-0'>
                            <div className={clsx('tab-pane', { active: tab === 'TimesheetApprovalList' })}>
                                <div className="table-responsive mt-4">
                                    <table className="table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1">
                                        <thead>
                                            <tr className="thHeading align-middle"  >
                                                <th className='w-25px'>
                                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                        <input
                                                            className='form-check-input'
                                                            type='checkbox'
                                                            checked={timesheetApprovalList.every((item: any) => item.isSelected === 0) ? false :
                                                                (timesheetApprovalList.every((item: any) => item.isSelected === 1 ? true : false))
                                                            }
                                                            onChange={handleSelectAllChange}
                                                        />
                                                    </div>
                                                </th>
                                                <th className='col'>
                                                    {/* {t("Employee Name")} */}
                                                    {getValueFromResource('Employee Name', dispatch, t)}
                                                </th>
                                                <th className='col'>
                                                    {/* {t("Hours")} */}
                                                    {getValueFromResource('Hours', dispatch, t)}
                                                </th>
                                                <th className='col'>
                                                    {/* {t("Billable Hours")} */}
                                                    {getValueFromResource('Billable Hours', dispatch, t)}
                                                </th>
                                                <th className='col'>
                                                    {/* {t("Non Billable Hours")} */}
                                                    {getValueFromResource('Non Billable Hours', dispatch, t)}
                                                </th>
                                                <th className='w-250px'></th>
                                                <th className='w-25px text-center'></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {timesheetApprovalList.length > 0 && timesheetApprovalList.map((item,  index: number) => {
                                                return (
                                                    <tr key={item.AccountEmployeeTimeEntryPeriodId}>
                                                        <td>
                                                            <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>

                                                                <input
                                                                    key={index}
                                                                    type="checkbox"
                                                                    className="form-check-input widget-9-check"
                                                                    checked={item.isSelected === 1}
                                                                    onChange={(e) => {
                                                                        handleCheckboxChange(e, index)
                                                                    }}
                                                                />

                                                            </div>
                                                        </td>
                                                        <td>
                                                            <a
                                                                id="btnPrintEmployeeName"
                                                                className='cursor'
                                                                ref={modelRef}
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#timesheetPrintModal"
                                                                onClick={() => { triggerTimesheetPrintView(item.AccountEmployeeTimeEntryPeriodId, item.SystemApproverType, item.TimeEntryStartDate, item.TimeEntryEndDate, item.TimeEntryAccountEmployeeId, item.EmployeeName) }}
                                                            >
                                                                {renderEmployeeNameWithSystemApproverType(item.EmployeeName, item.TimeEntryStartDate, item.TimeEntryEndDate, item.SystemApproverTypeId)}
                                                            </a>
                                                        </td>
                                                        <td>
                                                            <a className='text-dark fw-bold d-inline-block'>
                                                                {/* {item.Hours} */}
                                                                {decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), Number(item.Hours), 2) : displayValueForTimeEntry(item.Hours, false, showDecimal)}
                                                            </a>
                                                            <span style={{ color: '#7b8ba6', fontSize: 11, marginLeft: '3px', display: 'inline-block' }}>
                                                                {/* hrs */}
                                                                {getValueFromResource('hrs', dispatch, t)}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <a className='text-dark fw-bold d-inline-block'>
                                                                {/* {item.BillableHours} */}
                                                                {decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), Number(item.BillableHours), 2) : displayValueForTimeEntry(item.BillableHours, false, showDecimal)}
                                                            </a>
                                                            <span style={{ color: '#7b8ba6', fontSize: 11, marginLeft: '3px', display: 'inline-block' }}>
                                                                {/* hrs */}
                                                                {getValueFromResource('hrs', dispatch, t)}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <a className='text-dark fw-bold d-inline-block'>
                                                                {/* {item.NonBillableHours} */}
                                                                {decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), Number(item.NonBillableHours), 2) : displayValueForTimeEntry(item.NonBillableHours, false, showDecimal)}
                                                            </a>
                                                            <span style={{ color: '#7b8ba6', fontSize: 11, marginLeft: '3px', display: 'inline-block' }}>
                                                                {/* hrs */}
                                                                {getValueFromResource('hrs', dispatch, t)}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <button
                                                                    id="Approved"
                                                                    className={`btn btn-outline btn-sm btn-outline me-0 mb-0 btn-active-light-dark  me-1`}
                                                                    onClick={(e: any) => handleButtonClick(e, item.accountemployeeid, item.AccountEmployeeTimeEntryPeriodId, "Approved")}
                                                                >
                                                                    <i className="bi bi-check iconApprove p-0"></i>
                                                                    <span style={{ color: '#009688' }}>
                                                                        {/* {t("Approved")} */}
                                                                        {getValueFromResource('Approve', dispatch, t)}
                                                                    </span>
                                                                </button>
                                                                &nbsp;
                                                                <button
                                                                    id="Rejected"
                                                                    className={`btn btn-outline btn-sm btn-outline me-0 mb-0 btn-active-light-dark`}
                                                                    onClick={(e: any) => handleButtonClick(e, item.accountemployeeid, item.AccountEmployeeTimeEntryPeriodId, "reject")}
                                                                >
                                                                    <i className="bi bi-x iconReject p-0"></i>
                                                                    <span style={{ color: '#E53935' }}>
                                                                        {/* {t("Rejected")} */}
                                                                        {getValueFromResource('Reject', dispatch, t)}
                                                                    </span>
                                                                </button>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="btn-group" style={{ float: 'right' }}>
                                                                <a
                                                                    className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                    data-tooltip-id="tooltip-Description"
                                                                    data-tooltip-content=
                                                                    // {t("Comments")}
                                                                    {getValueFromResource('Comments', dispatch, t)}
                                                                    data-tooltip-place="bottom">
                                                                    <i className="bi bi-chat-square-text fs-3 iconColor"></i>
                                                                </a>
                                                                <ul className="dropdown-menu menu-column menu-rounded menu-gray-600 px-4 py-4 fs-2 w-300px" role="menu">
                                                                    <div className='menu-item text-gray-800'>
                                                                        <div className="dropdown-menu-item">
                                                                            <textarea
                                                                                placeholder=
                                                                                {getValueFromResource('Your comments here...', dispatch, t)}
                                                                                className="form-control fs-7 fw-normal"
                                                                                rows={4}
                                                                                style={{ borderRadius: 2 }}
                                                                                onChange={(e) => handleCommentsChange(e, item.AccountEmployeeTimeEntryPeriodId)}
                                                                                value={item.Comments}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </ul>
                                                                <a
                                                                    className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                                    data-tooltip-id="tooltip-Description"
                                                                    data-tooltip-content=
                                                                    // {t("Attachment")}
                                                                    {getValueFromResource('Attachment', dispatch, t)}
                                                                    data-tooltip-place="bottom"
                                                                    onClick={() => handleAttachment(item.AccountEmployeeTimeEntryPeriodId)}
                                                                >
                                                                    <i className="bi bi-paperclip fs-3 iconColor"></i>
                                                                </a>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                    {timesheetApprovalList.length === 0 &&
                                        <div className=''>
                                            <p className='noDataFound'>
                                                {/* {t('No Record Found')} */}
                                                {getValueFromResource('No Record Found', dispatch, t)}
                                            </p>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className={clsx('tab-pane', { active: tab === 'TimeoffApprovalList' })}>
                                <div className="table-responsive mt-4">
                                    <table className="table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1">
                                        <thead>
                                            <tr className="thHeading align-middle">
                                                <th className='w-25px'>
                                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                        <input
                                                            className='form-check-input'
                                                            type='checkbox'
                                                            checked={timeoffApprovalList.every((item: any) => item.isSelected === 0) ? false :
                                                                (timeoffApprovalList.every((item: any) => item.isSelected === 1 ? true : false))
                                                            }
                                                            onChange={handleSelectAllChangetimeoff}
                                                        />
                                                    </div>
                                                </th>
                                                <th className='col'>
                                                    {/* {t('Employee Name')} */}
                                                    {getValueFromResource('Employee Name', dispatch, t)}
                                                </th>
                                                <th className='col'>
                                                    {/* {t('Time Off Type')} */}
                                                    {getValueFromResource('Time Off Type', dispatch, t)}
                                                </th>
                                                <th className='col'>
                                                    {/* {t('Hours')} */}
                                                    {getValueFromResource('Hours', dispatch, t)}
                                                </th>
                                                {/* <th className='col'>
                                                   
                                                    {getValueFromResource('Days Off', dispatch, t)}
                                                </th> */}
                                                <th className='col'>
                                                    {/* {t('Available Hours')} */}
                                                    {getValueFromResource('Available Hours', dispatch, t)}
                                                </th>
                                                <th className='w-250px'></th>
                                                <th className='w-25px text-center'></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {timeoffApprovalList.length > 0 && timeoffApprovalList.map((item) => {
                                                return (
                                                    <tr key={item.AccountEmployeeId}>
                                                        <td>
                                                            <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input widget-9-check"
                                                                    checked={item.isSelected == 0 ? false : true}
                                                                    onChange={(e) => { handleCheckboxChangetimeoff(e, item.AccountEmployeeTimeEntryId) }}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            {renderEmployeeNameWithSystemApproverType(item.EmployeeName, item.TimeEntryDate, item.TimeEntryDate, item.SystemApproverTypeId)}
                                                        </td>
                                                        <td>
                                                            {/* <a className='text-dark fw-bold d-block'>
                                                                {item.AccountTimeOffType}
                                                            </a> */}
                                                            <span className="d-block mb-1">
                                                                {item.AccountTimeOffType}
                                                            </span>
                                                            {item.Description !== null ? (
                                                                <a
                                                                    style={{ fontSize: 'x-small', fontWeight: '500', lineHeight: '.7', cursor: 'pointer' }}
                                                                    className='text-dark fw-bold d-block'
                                                                    data-tooltip-id="tooltip-Description"
                                                                    data-tooltip-content={t(`${item.Description}`)}
                                                                    data-tooltip-place="bottom"
                                                                >
                                                                    {/* {t('View Description')} */}
                                                                    {getValueFromResource('View Description', dispatch, t)}
                                                                </a>
                                                            ) : null}
                                                        </td>
                                                        <td>
                                                            <a className='text-dark fw-bold d-inline-block'>
                                                                {/* {item.Hours} */}
                                                                {decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), Number(item.Hours), 2) : displayValueForTimeEntry(item.Hours, false, showDecimal)}
                                                            </a>
                                                            <span style={{ color: '#7b8ba6', fontSize: 11, marginLeft: '3px', display: 'inline-block' }}>
                                                                {/* hrs */}
                                                                {getValueFromResource('hrs', dispatch, t)}
                                                            </span>
                                                        </td>
                                                        {/* <td>
                                                            <a className='text-dark fw-bold d-block'>
                                                               
                                                                {FormatInvoiceDecimalNumber(cultureInfoName.toString(),  Number(item.DaysOff), 2)}
                                                            </a>
                                                        </td> */}
                                                        <td>
                                                            <a className='text-dark fw-bold d-block'>
                                                                {/* {item.AvailableHours} */}
                                                                {decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), Number(item.Available), 2) : displayValueForTimeEntry(item.Available, false, showDecimal)}
                                                            </a>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <button
                                                                    id="Approved"
                                                                    className={`btn btn-outline btn-sm btn-outline me-0 mb-0 btn-active-light-dark  me-1`}
                                                                    onClick={(e: any) => handleButtonClickForTimeOff(e, item.accountemployeeid, item.AccountEmployeeTimeEntryId, "Approved")}
                                                                >
                                                                    <i className="bi bi-check iconApprove p-0"></i>
                                                                    <span style={{ color: '#009688' }}>
                                                                        {/* {t('Approved')} */}
                                                                        {getValueFromResource('Approve', dispatch, t)}
                                                                    </span>
                                                                </button>
                                                                &nbsp;
                                                                <button
                                                                    id="Rejected"
                                                                    className={`btn btn-outline btn-sm btn-outline me-0 mb-0 btn-active-light-dark`}
                                                                    onClick={(e: any) => handleButtonClickForTimeOff(e, item.accountemployeeid, item.AccountEmployeeTimeEntryId, "Rejected")}
                                                                >
                                                                    <i className="bi bi-x iconReject p-0"></i>
                                                                    <span style={{ color: '#E53935' }}>
                                                                        {/* {t('Rejected')} */}
                                                                        {getValueFromResource('Reject', dispatch, t)}
                                                                    </span>
                                                                </button>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="btn-group" style={{ float: 'right' }}>
                                                                <a
                                                                    className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                    data-tooltip-id="tooltip-Description"
                                                                    data-tooltip-content=
                                                                    // {t("Comments")}
                                                                    {getValueFromResource('Comments', dispatch, t)}
                                                                    data-tooltip-place="top">
                                                                    <i className="bi bi-chat-square-text fs-3 iconColor"></i>
                                                                </a>
                                                                <ul className="dropdown-menu menu-column menu-rounded menu-gray-600 px-4 py-4 fs-2 w-300px" role="menu">
                                                                    <div className='menu-item text-gray-800'>
                                                                        <div className="dropdown-menu-item">
                                                                            <textarea
                                                                                placeholder=
                                                                                // {t("Your comments here...")}
                                                                                {getValueFromResource('Your comments here...', dispatch, t)}
                                                                                className="form-control fs-7 fw-normal"
                                                                                rows={4}
                                                                                style={{ borderRadius: 2 }}
                                                                                onChange={(e) => handleCommentsChangeTimeOff(e, item.AccountEmployeeTimeEntryId)}
                                                                                value={item.Comments}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </ul>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                    {timeoffApprovalList.length === 0 &&
                                        <div className=''>
                                            <p className='noDataFound'>
                                                {/* {t('No Record Found')} */}
                                                {getValueFromResource('No Record Found', dispatch, t)}
                                            </p>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <TimesheetPrintViewWidget ref={modelRef} showDecimal={showDecimal} />
            {/* <TimesheetPrintViewWidget ref={modelRef} accountEmployeeTimeEntryPeriodId={isOpenTimesheetPrintModal} SystemApproverType={propSystemApproverType} startDate={startDate} endDate={endDate} isForTimesheet={false} accountEmployeeIdRows={AccountEmployeeIdRowsClick} approverEmployeeId={sessionAccountEmployeeId} /> */}
            <TaskOffCanvas obj={generalObject} />
        </>
    )
}

export default TimesheetApproval